module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.initialized) ? _c('md-button', {
    class: _vm.buttonCls,
    on: {
      "click": _vm.onClickMic
    }
  }, [_c('md-icon', {
    staticClass: "md-size-4x"
  }, [_vm._v("mic")])], 1) : _c('div', [_vm._v("\n  There's no mic available on this device.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fde5c6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecordButton.vue
// module id = 99
// module chunks = 2